export const DRAGGABLE_ATTRIBUTE = "DRAGGABLE_ATTRIBUTE";
